// Malay translations (Bahasa Melayu)
export const ms = {
  // Common
  common: {
    home: 'Utama',
    settings: 'Tetapan',
    language: 'Bahasa',
    loading: 'Memuatkan...',
    save: 'Simpan',
    cancel: 'Batal',
    confirm: 'Sahkan',
    close: 'Tutup',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Tetapan',
    home: 'Utama',
    howToPlay: 'Cara Bermain',
    pieceRules: 'Peraturan Buah',
    language: 'Bahasa',
    manageSubscription: 'Urus Langganan',
    gameHistory: 'Sejarah Permainan',
    analytics: 'Analitik',
    premiumAccount: 'Akaun Premium',
    chatEnabled: 'Sembang: Aktif',
    chatDisabled: 'Sembang: Tidak Aktif',
  },

  // Piece Rules
  pieceRules: {
    title: 'Peraturan Buah',
    description: 'Pelajari pergerakan buah',
    selectPiece: 'Pilih Buah',
    selectedLabel: 'Dipilih:',
    statusLabel: 'Status:',
    statusReady: 'Sedia',
    statusViewing: 'Melihat',
    movement: 'Pergerakan',
    regularMovement: 'Pergerakan Biasa',
    ability: 'Kebolehan',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Pergerakan',
    savage: 'Ganas',
    birdtype: 'Jenis Burung',
    birdType: 'Jenis Burung',
    wallBlock: 'Halangan Dinding',
    moveblocks: 'Halangan Pergerakan',
    wallclimb: 'Panjat Dinding',
    lilypad: 'Daun Teratai',
    poisonous: 'Beracun',
    meadow: 'Padang Rumput',
    parasiticfungi: 'Kulat Parasit',
    zombification: 'Zombifikasi',
    fungi: 'Kulat',
    traverse: 'Melintasi',
    capture: 'Tangkap',
    faint: 'Pengsan',
    leap: 'Lompat',
    swing: 'Ayun',
    consume: 'Makan',
    gamble: 'Pertaruhan',
    entangle: 'Jerat',
    ink: 'Dakwat',
    rotate: 'Putar',
    backstep: 'Undur',
    trample: 'Pijak',
    charge: 'Serangan',
    lane: 'Lorong',
    snakestrike: 'Sergapan Ular',
    shedskin: 'Tanggalkan Kulit',
    house: 'Rumah',
    plant: 'Jenis Tumbuhan',
    planttype: 'Jenis Tumbuhan',
    capturehost: 'Tangkap Tuan Rumah',
    contagion: 'Penularan',
    lonewolf: 'Serigala Penyendiri',
    hop: 'Lompat',
    decay: 'Reput',
    slide: 'Gelongsor',
    block: 'Halang',
    poison: 'Racun',
    infection: 'Jangkitan',
    howl: 'Lolongan',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'Beruang boleh bergerak satu petak ke mana-mana arah, seperti raja dalam catur',
    bearMovementPost: 'Ia hanya disekat oleh buah rakan (kecuali Pokok, Beruang boleh memanjat Pokok!)',
    bearSavage: 'Beruang boleh mengatasi kebolehan pertahanan seperti Halangan Badak',
    bearSavagePost: 'Menggunakan Ganas, Beruang boleh menangkap mana-mana buah dari mana-mana arah, menambah daya maut',

    // Crane
    craneMovement: 'Burung Jenjang boleh bergerak 1 atau 2 petak dalam mana-mana garis lurus',
    craneMovementPost: 'Burung Jenjang juga boleh terbang melepasi buah lain!',
    craneBirdType: 'Buah jenis burung tidak boleh menangkap buah besar atau pemangsa',
    craneBirdTypePost: 'Ini termasuk Pokok, Badak, Beruang dan Serigala',

    // Frog
    frogMovement: 'Katak melompat 2 petak secara pepenjuru',
    frogMovementPost: 'Ia tidak boleh melompat hanya satu petak',
    frogWallBlock: 'Jika laluan biasa 2 petak Katak disekat oleh dinding atau buah lain, ia tidak boleh menangkap',
    frogWallBlockPost: 'Pergerakan biasanya dipendekkan kepada 1 petak secara pepenjuru',
    frogWallClimb: 'Apabila Katak berada di dinding papan (Lajur A atau E), ia boleh bergerak naik atau turun satu',
    frogWallClimbPost: 'Melainkan disekat oleh buah rakan atau Badak di hadapan Katak',
    frogLilypad: 'Jika Katak belum bergerak dalam permainan, ia boleh bergerak ke mana-mana daripada 3 peringkat pertama sebagai kebolehan pertahanan yang kuat',
    frogLilypadPost: 'Ia boleh menangkap mana-mana buah biasa menggunakan Lompatan Daun Teratai, kecuali Badak pada peringkat yang lebih tinggi daripada dirinya',
    frogPoisonous: 'Apabila mana-mana haiwan menangkap buah Katak, anda menjadi beracun!',
    frogPoisonousPost: 'Buah beracun melangkau giliran seterusnya yang tersedia sebelum ia pulih',

    // Fungi
    fungiMovement: 'Kulat boleh bergerak satu petak ke mana-mana arah',
    fungiMovementPost: 'Ia hanya disekat oleh buah sekutu',
    fungiMeadow: 'Kulat mengurangkan kebolehan pergerakan buah Pokok musuh',
    fungiMeadowPost: 'Buah Pokok musuh tidak boleh bergerak dalam 1 petak daripada buah Kulat',
    fungiParasitic: 'Kulat boleh melumpuhkan buah Pokok musuh',
    fungiParasiticPost: 'Jika Kulat berada dalam 1 petak daripada Pokok musuh, ia tidak boleh bergerak sehingga Kulat bergerak atau ditangkap',
    fungiZombification: 'Kulat boleh menzombikan mana-mana buah haiwan musuh yang menangkapnya, membenarkan kawalan ke atas haiwan musuh untuk satu giliran',
    fungiZombificationPost: 'Buah yang dizombikan juga dianggap sebagai buah Kulat untuk giliran itu, walaupun Kulat adalah raja anda, permainan tidak berakhir sehingga selepas giliran itu',
    fungiFungi: 'Cendawan',
    fungiFungiPost: 'Seperti racun, jeratan dan jangkitan virus, tetapi bukan zombifikasi kerana ia boleh menzombikan yang lain!',

    // Goat
    goatMovement: 'Kambing boleh bergerak satu petak ke mana-mana arah',
    goatMovementPost: 'Kambing bergerak perlahan tetapi mempunyai kebolehan yang kuat',
    goatTraverse: 'Kambing boleh melintasi mana-mana buah lain yang bersambung untuk mencipta potensi pergerakan yang besar',
    goatTraversePost: 'Kambing tidak boleh melintasi Kambing Pengsan atau buah Kecil seperti Virus',
    goatCapture: 'Kambing tidak boleh menangkap mana-mana Pemangsa',
    goatCapturePost: 'Seperti Beruang atau Serigala',
    goatFaint: 'Kambing boleh pengsan untuk mengelak tangkapan kecuali daripada buah besar seperti Pokok dan Badak',
    goatFaintPost: 'Semasa pengsan, lawan boleh \'berdiri\' di atas kambing pengsan untuk menghentikan pergerakannya',

    // Monkey
    monkeyMovement: 'Monyet boleh bergerak satu petak ke mana-mana arah',
    monkeyMovementPost: 'Tanpa buah lain untuk digunakan, Monyet mempunyai pergerakan terhad',
    monkeyLeap: 'Monyet, seperti permainan dam, boleh melompat ke atas buah lain dalam garis lurus untuk potensi pergerakan yang besar',
    monkeyLeapPost: 'Tetapi jika melompat ke atas buah musuh, Monyet mesti melempar dadu untuk terus hidup, peluang 1/6 untuk ditangkap bagi setiap musuh yang dilompati!',
    monkeySwing: 'Jika Monyet menggunakan lompatan ke atas Pokok, Monyet mendapat giliran bonus',
    monkeySwingPost: 'Menggunakan ayunan Pokok mencipta kombo sinergi yang kuat antara Monyet dan buah Pokok',
    monkeyConsume: 'Monyet boleh memakan buah Kulat untuk giliran bonus',
    monkeyConsumePost: 'Membawa kepada kombinasi yang dahsyat apabila digabungkan dengan giliran bonus lain',
    monkeyGamble: 'Selain melempar dadu untuk melompat ke atas musuh, Monyet mesti bertaruh untuk menangkap Beruang',
    monkeyGamblePost: 'Monyet mesti melempar 5 atau 6 pada dadu 6 sisi untuk menangkap Beruang atau ia akan ditangkap',

    // Octopus
    octopusMovement: 'Sotong bergerak satu petak ke mana-mana arah',
    octopusCapture: 'Sotong hanya boleh menangkap secara ortogonal',
    octopusCapturePost: 'Sotong boleh menangkap atau menjerat buah dengan cara yang kompleks jadi sentiasa periksa tangkapan merah dan jeratan ungu!',
    octopusEntangle: 'Sotong boleh menjerat buah musuh bersebelahan, melumpuhkan mereka, ia juga boleh bergerak satu petak dan menjerat musuh!',
    octopusEntanglePost: 'Buah yang terjerat tidak boleh bergerak sehingga Sotong bergerak atau ditangkap',
    octopusInk: 'Sotong boleh menggunakan dakwat untuk melarikan diri dari situasi berbahaya, mencipta sehingga 3 bayangan',
    octopusInkPost: 'Mengelirukan musuh dan membenarkan permainan umpan dan pengelakan yang menarik',

    // Penguin
    penguinMovement: 'Penguin meluncur dalam garis lurus mengikut arah yang ditetapkan sehingga dinding atau buah menghalang pergerakannya',
    penguinMovementPost: 'Selepas bergerak, Penguin dalam giliran yang sama boleh menetapkan arah akhirnya juga',
    penguinRotate: 'Pada permulaan perlawanan, Penguin menghadap ke bawah dan mesti berputar sebelum dapat meluncur, juga dikenali sebagai tidur',
    penguinRotatePost: 'Penguin di mana-mana kedudukan boleh memilih untuk berputar dan bukannya bergerak',
    penguinBirdType: 'Penguin mempunyai kebolehan tangkapan terhad, seperti Burung Jenjang, ia tidak boleh menangkap buah besar atau pemangsa seperti Pokok, Badak, Beruang atau Serigala',
    penguinBirdTypePost: 'Selepas menangkap, Penguin boleh berputar untuk menghadap mana-mana arah untuk kedudukan strategik',

    // Rhino
    rhinoMovement: 'Badak bergerak dua petak ke hadapan sahaja',
    rhinoMovementPost: 'Ia tidak boleh bergerak hanya 1 petak',
    rhinoBackStep: 'Badak boleh bergerak belakang-kiri atau belakang-kanan',
    rhinoCharge: 'Badak sekali setiap permainan boleh bergerak satu petak tambahan ke hadapan menggunakan kebolehan serangannya',
    rhinoChargePost: 'Membawa kepada potensi pergerakan dan tangkapan yang dahsyat',
    rhinoTrample: 'Badak menangkap semua buah dalam laluan perjalanannya dengan Pijakan',
    rhinoTramplePost: 'Termasuk buah Kambing pengsan',
    rhinoLane: 'Badak boleh bertukar tempat dengan buah sekutu lain membenarkan permainan lorong strategik',
    rhinoLanePost: 'Tetapi hanya jika Badak dan buah Sekutu kedua-duanya belum bergerak',

    // Snake
    snakeMovement: 'Ular boleh bergerak 2 petak dalam mana-mana garis lurus',
    snakeMovementPost: 'Ular bergerak tepat 2 petak melainkan disekat oleh dinding atau buah rakan',
    snakeMoveBlocks: 'Apabila disekat oleh dinding atau buah yang tidak boleh ditangkap, pergerakan Ular dipendekkan kepada 1 petak',
    snakeMoveBlocksPost: 'Ia masih boleh bergerak dua petak walaupun ada buah perantaraan',
    snakeStrike: 'Ular boleh menyergap 3 petak ke hadapan jika ada haiwan musuh',
    snakeStrikePost: 'Selagi tiada buah perantaraan menghalang laluannya',
    snakeShedskin: 'Sekali setiap permainan, Ular boleh menanggalkan kulitnya dan kembali ke peringkat pertama jika petak itu kosong',
    snakeShedskinPost: 'Kelahiran semula ini memberikan Ular nyawa tambahan setiap permainan',

    // Tree
    treeMovement: 'Pokok boleh bergerak satu petak ke hadapan atau ke mana-mana petak pada peringkatnya dari sisi ke sisi',
    treeMovementPost: 'Selagi laluannya tidak disekat',
    treeHouse: 'Pokok boleh menempatkan buah lain, melindungi mereka daripada musuh yang tidak boleh memanjat Pokok. Mungkin buah boleh memanjat seperti Beruang, Burung Jenjang, Katak, Kulat, Kambing, Monyet, Sotong dan Ular',
    treeHousePost: 'Apabila buah yang boleh memanjat pokok menyerang, ia hanya menangkap buah yang ditempatkan, melindungi Pokok',
    treeTrample: 'Pokok seperti Badak, menangkap semua buah dalam satu petak apabila ia bergerak',
    treeTramplePost: 'Ini termasuk Kambing pengsan',
    treePlant: 'Pokok adalah tumbuhan, bukan haiwan jadi ia kebal kepada beberapa kesan',
    treePlantPost: 'Seperti racun, zombifikasi, jeratan dan jangkitan virus!',

    // Virus
    virusMovement: 'Virus hanya boleh bergerak ke petak yang diduduki dengan haiwan, yang berjarak dua petak',
    virusMoveBlocks: 'Virus boleh bergerak hanya satu petak jika ia bersebelahan dengan dinding',
    virusCaptureHost: 'Apabila Virus mendarat di (dalam) mana-mana buah haiwan, ia hanya menjangkiti mereka, mereka masih boleh meneruskan permainan biasa semasa dijangkiti',
    virusCaptureHostPost: 'Virus hanya menangkap buah apabila ia meninggalkan tuan rumah yang dijangkiti',
    virusContagion: 'Virus boleh merebak dengan cepat dengan menjangkiti beberapa tuan rumah dalam satu giliran',
    virusContagionPost: 'Penularan membenarkan Virus membuat seberapa banyak pergerakan sah yang ia suka setiap giliran',

    // Wolf
    wolfMovement: 'Serigala boleh bergerak dalam bentuk L, seperti kuda dalam catur',
    wolfMovementPost: 'Ia tidak disekat oleh buah lain',
    wolfLoneWolf: 'Serigala',
    wolfLoneWolfPost: 'Serigala juga menganggap dirinya penyendiri apabila ia masih mempunyai Kambing pengsan atau sekutu virus',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Seret untuk meneroka • Cubit untuk zum',
    dragToExploreDesktop: '🖱️ Seret untuk meneroka • Tatal untuk zum',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Kembali',
    next: 'Seterusnya',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'KOTAK PASIR',
    description: 'Eksperimen & Latihan',
    mode: 'Mod:',
    modeValue: 'Kotak Pasir',
    status: 'Status:',
    statusReady: 'Sedia',
    clearBoard: 'Kosongkan Papan',
  },

  // Multiplayer
  multiplayer: {
    title: 'BERBILANG PEMAIN',
    description: 'Cari perlawanan anda dan bersaing!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Perlawanan Penempatan',
    matchProgress: 'Kemajuan Perlawanan',
    gamesCompleted: '{games} / 10 Permainan Selesai',
    estimatedFinalRating: 'Anggaran Penarafan Akhir',
    startingRating: 'Penarafan permulaan',
    matchesRemaining: '{matches} perlawanan lagi',
    findPlacementMatch: 'Cari Perlawanan Penempatan',

    // Matchmaking modes
    findMatch: 'Cari Perlawanan',
    competitive: 'Kompetitif',
    competitiveDesc: 'Cari lawan berhampiran kedudukan anda',
    quick: 'Pantas',
    quickDesc: 'Cari perlawanan kompetitif dengan cepat',
    casual: 'Santai',
    casualDesc: 'Tanpa kedudukan - main untuk keseronokan!',
    placement: 'Penempatan',
    placementDesc: 'Lengkapkan 10 perlawanan untuk mendapat kedudukan',
    startSearch: 'Mula Carian',

    // Searching
    searching: 'Mencari...',
    mode: 'Mod:',
    inQueue: 'Dalam Barisan:',
    players: 'pemain',
    playersPlural: 'pemain',
    cancelSearch: 'Batal Carian',

    // Game info
    status: 'Status:',
    ready: 'Sedia',
    selectingKing: 'Memilih Raja',
    placingPieces: 'Meletakkan Buah',
    playing: 'Bermain',
    gameType: 'Jenis Permainan:',
    opponent: 'Lawan:',
    opponentElo: 'ELO Lawan:',
    unranked: 'Tanpa Kedudukan',

    // Piece placement
    dragPieces: 'Seret buah ke papan',
    lightPieces: 'Buah Cerah (Anda)',
    darkPieces: 'Buah Gelap (Anda)',

    // Waiting states
    waitingForOpponent: 'Menunggu Lawan...',
    waitingForKing: 'Menunggu lawan memilih raja mereka...',

    // Warnings
    invalidPlacement: 'Penempatan Tidak Sah',
    lightTurn: 'Giliran pemain Cerah!',
    darkTurn: 'Giliran pemain Gelap!',
    onlyLightPieces: 'Anda hanya boleh meletakkan buah cerah!',
    onlyDarkPieces: 'Anda hanya boleh meletakkan buah gelap!',
    mustPlaceOnRow: 'Buah {color} mesti diletakkan pada baris {row}!',

    // Chat
    chat: 'Sembang',
    typeMessage: 'Taip mesej...',
    send: 'Hantar',
  },

  // Main Page
  mainPage: {
    title: 'CATUR HAIWAN',
    subtitle: 'Permainan untuk manusia',
    playersOnline: 'Pemain dalam talian sekarang',
    placement: 'Penempatan',
    placementProgress: 'Penempatan',
    challengeAI: 'Cabaran AI',
    multiplayer: 'Berbilang Pemain',
    sandbox: 'Kotak Pasir',
    tutorials: 'Tutorial',
    shop: 'Kedai',
    collection: 'Koleksi',
    history: 'Sejarah',
    analytics: 'Analitik',
    courses: 'Kursus',
    upgradeAccount: 'Naik taraf akaun',
    signIn: 'Log Masuk',
    playAsGuest: 'Main sebagai Tetamu',
    welcomeBack: 'Selamat kembali! Anda biasanya bermain sebagai',

    // Learn the Pieces section
    learnThePieces: 'Pelajari buah-buah',

    // Learn the Rules section
    learnTheRules: 'Pelajari Peraturan',
    premiseTitle: 'Premis',
    premiseText: 'Zodiac adalah alternatif catur dengan raja TERSEMBUNYI daripada senarai 13 buah, pilih senarai yang unik dan kemudian bluf lawan anda untuk mengalahkan mereka pada papan 5 kali 8',
    selectionTitle: 'Pemilihan',
    selectionText: 'Untuk memulakan permainan, pilih raja anda secara rahsia, kemudian letakkan 5 buah anda secara bergilir-gilir dengan lawan anda untuk mencipta salah satu daripada lebih 500 bilion keadaan awal.',
    objectiveTitle: 'Objektif',
    objectiveText: 'Sama ada baca lawan anda untuk MENANGKAP raja rahsia mereka atau BERLUMBA raja anda merentasi papan untuk mendapatkan kemenangan!',
    competeTitle: 'Bersaing',
    competeText: 'Uji kemahiran anda di tangga, kembangkan teknik dan strategi peribadi yang baharu, naik pangkat untuk menghadapi yang terbaik!',
    fullRulesButton: 'Untuk peraturan rasmi penuh klik di sini',

    // FAQ section
    faqTitle: 'Soalan Lazim',
    faqQuestion1: 'Apakah idea di sebalik catur Zodiac?',
    faqAnswer1: 'Catur Zodiac pada mulanya diilhamkan oleh kata-kata Bobby Fischer tentang inspirasinya untuk mencipta Chess960, kami mahu mengembangkan idea memerangi hafalan rote dan meraikan intuisi manusia dalam kedalaman yang tidak dapat dibayangkan!',
    faqQuestion2: 'Mengapa kita memerlukan alternatif catur',
    faqAnswer2: 'Kami tidak! Zodiac tidak mahu menghalang orang daripada bermain catur! Ia adalah pilihan yang berbeza dengan kekuatan dan kelemahan sendiri, kami berharap anda berseronok dengannya dan membantu kami menyesuaikan permainan ini untuk menghidupkan permainan novel',
    faqQuestion3: 'Bagaimana untuk menang dalam Catur Zodiac?',
    faqAnswer3: 'Terdapat tiga cara untuk menang: tangkap buah raja tersembunyi lawan anda, lumba raja anda sendiri ke seberang papan, atau dalam perlawanan dengan kawalan masa, masa lawan anda habis',
    faqQuestion4: 'Adakah ini FAQ?',
    faqAnswer4: 'Ya, anda boleh melihat mana-mana soalan yang disenaraikan dalam FAQ dan jika anda mahu butiran lanjut, anda boleh klik pada soalan dan kemudian baca butiran berikut, seperti butiran yang anda baca sekarang',
    faqQuestion5: 'Berapa lama permainan biasa mengambil masa?',
    faqAnswer5: 'Setiap permainan berbeza dengan ketara! Sesetengah permainan tamat dalam 2 gerakan dan sesetengahnya mungkin mengambil masa 30 minit, kami biasanya cenderung mendapati mereka di tanda 5-15 minit!',
    faqQuestion6: 'Apa yang berlaku jika tiada siapa boleh membuat gerakan yang sah?',
    faqAnswer6: 'Jika pemain tidak boleh membuat sebarang gerakan yang sah (stalemate), permainan berakhir dengan seri. Permainan juga boleh berakhir dengan seri melalui pengulangan (keadaan papan yang sama 3 kali) atau melalui persetujuan bersama antara pemain!',

    // About section
    aboutButton: 'Tentang',
    privacyPolicy: 'Dasar Privasi',
    developerInterface: 'Antara Muka Pembangun',
  },

  // About Modal
  about: {
    title: 'Tentang Zodiac',
    paragraph1: 'Zodiac adalah permainan papan seperti catur yang menggabungkan elemen pemilihan buah daripada permainan seperti LoL dan DotA, dengan mekanik bluffing daripada poker atau permainan deduksi sosial.',
    paragraph2: 'Versi awal permainan dicipta pada 2014, di bawah nama Shadow Chess. Pada 2018 ia direka semula untuk menjadi apa yang anda lihat hari ini, melibatkan senarai buah yang menyeronokkan dengan corak pergerakan dan kebolehan yang seimbang tetapi unik.',
    paragraph3: 'Visi kami adalah untuk merekodkan semua data permainan pengguna untuk terus mengembangkan permainan dalam usaha mengekalkan permainan yang menyegarkan, menggalakkan permainan novel.',
    paragraph4: 'Dengan ruang carian gergasi Zodiac, maklumat tersembunyi dan kedudukan papan pembukaan kami berharap dapat menahan penguasaan AI dan mengekalkan zodiac sebagai permainan untuk manusia!',
  },

  // Privacy Policy
  privacy: {
    title: 'Dasar Privasi',
    lastUpdated: 'Kemas Kini Terakhir',

    introduction: {
      title: 'Pengenalan',
      p1: 'Selamat datang ke Zodiac Chess ("kami", "milik kami" atau "kami"). Kami komited untuk melindungi privasi anda dan memastikan anda mempunyai pengalaman permainan yang selamat dan menyeronokkan. Dasar Privasi ini menerangkan bagaimana kami mengumpul, menggunakan, mendedahkan, dan melindungi maklumat anda apabila anda menggunakan laman web dan permainan kami.',
      p2: 'Dengan menggunakan Zodiac Chess, anda bersetuju dengan pengumpulan dan penggunaan maklumat mengikut dasar ini. Jika anda tidak bersetuju dengan dasar dan amalan kami, sila jangan gunakan perkhidmatan kami.',
      contact: 'Hubungi kami di:',
    },

    infoCollect: {
      title: 'Maklumat yang Kami Kumpulkan',
      accountInfo: {
        title: '1. Maklumat Akaun',
        item1: 'Alamat E-mel: Diperlukan untuk penciptaan akaun dan komunikasi',
        item2: 'Nama Pengguna: Nama paparan pilihan anda',
        item3: 'Kata Laluan: Disulitkan dan disimpan dengan selamat',
      },
      gameData: {
        title: '2. Data Permainan',
        item1: 'Statistik Permainan: Kemenangan, kekalahan, penarafan ELO, kemajuan perlawanan penempatan',
        item2: 'Data Permainan: Pemilihan buah, gerakan yang dibuat, strategi yang digunakan',
        item3: 'Sejarah Perlawanan: Rekod permainan yang dimainkan, lawan yang dihadapi',
        item4: 'Pembelian Dalam Permainan: Item kosmetik dan status keahlian premium',
      },
      technicalData: {
        title: '3. Data Teknikal',
        item1: 'Maklumat Peranti: Jenis pelayar, sistem operasi',
        item2: 'Data Penggunaan: Halaman yang dilawati, masa yang dihabiskan, ciri yang digunakan',
        item3: 'Storan Tempatan: Pilihan bahasa, tetapan UI, keadaan permainan sementara',
      },
    },

    children: {
      title: 'Privasi Kanak-kanak (Pematuhan COPPA)',
      p1: 'Zodiac Chess direka untuk mesra keluarga dan sesuai untuk pemain semua peringkat umur, termasuk kanak-kanak. Kami mengambil perhatian khusus untuk mematuhi Akta Perlindungan Privasi Kanak-kanak Dalam Talian (COPPA).',
      p2: 'Untuk pengguna di bawah umur 13 tahun: Kami mengesyorkan agar kanak-kanak menggunakan mod main tetamu kami, yang tidak memerlukan penciptaan akaun atau pengumpulan data. Akaun tetamu tidak mempunyai akses kepada ciri sembang teks, memastikan kanak-kanak tidak terdedah kepada komunikasi dengan internet yang lebih luas. Jika kanak-kanak mencipta akaun, kami memerlukan persetujuan ibu bapa sebelum mengumpul sebarang maklumat peribadi.',
      p3: 'Kami TIDAK dengan sengaja mengumpul, menggunakan, atau berkongsi maklumat peribadi daripada kanak-kanak di bawah 13 tahun tanpa persetujuan ibu bapa yang disahkan.',
      p4: 'Keselamatan Sembang: Sembang teks dilumpuhkan secara automatik untuk semua akaun tetamu/sementara. Pemegang akaun standard mempunyai pilihan untuk melumpuhkan fungsi sembang dalam tetapan akaun mereka pada bila-bila masa.',
      parentalRights: 'Ibu bapa mempunyai hak untuk:',
      right1: 'Menyemak maklumat peribadi anak mereka',
      right2: 'Meminta pemadaman data anak mereka',
      right3: 'Menolak pengumpulan atau penggunaan selanjutnya maklumat anak mereka',
      contactUs: 'Untuk menggunakan hak ini atau jika anda percaya anak anda telah memberikan maklumat peribadi kepada kami, sila hubungi kami segera di contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Bagaimana Kami Menggunakan Maklumat Anda',
      item1: 'Menyediakan dan meningkatkan perkhidmatan permainan kami',
      item2: 'Memadankan anda dengan lawan yang sesuai berdasarkan tahap kemahiran',
      item3: 'Menjejaki kemajuan, statistik dan pencapaian anda',
      item4: 'Memproses pembayaran untuk keahlian premium dan item kosmetik',
      item5: 'Menghantar pengumuman perkhidmatan penting dan kemas kini',
      item6: 'Menganalisis data permainan untuk meningkatkan keseimbangan permainan dan ciri',
    },

    thirdParty: {
      title: 'Perkhidmatan Pihak Ketiga',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Kami menggunakan Firebase untuk pengesahan, penyimpanan pangkalan data, dan fungsi berbilang pemain. Firebase mungkin mengumpul data tertentu seperti yang diterangkan dalam dasar privasi mereka.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Kami menggunakan Stripe untuk memproses pembayaran untuk keahlian premium dan pembelian dalam aplikasi. Stripe mengendalikan semua maklumat kad pembayaran - kami tidak pernah melihat atau menyimpan butiran pembayaran penuh anda.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Laman web kami dihoskan di Netlify, yang mungkin mengumpul data hosting web standard seperti alamat IP dan log akses.',
      },
      adsense: {
        title: 'Google AdSense (Masa Depan)',
        description: 'Kami mungkin memaparkan iklan melalui Google AdSense. Iklan ini mungkin menggunakan kuki untuk pemperibadian. Untuk kandungan yang ditujukan kepada kanak-kanak, kami hanya akan menunjukkan iklan tidak diperibadikan mematuhi COPPA.',
      },
      viewPolicy: 'Lihat Dasar Privasi mereka',
    },

    cookies: {
      title: 'Kuki dan Storan Tempatan',
      description: 'Kami menggunakan storan tempatan pelayar (serupa dengan kuki) untuk meningkatkan pengalaman anda:',
      item1: 'Pilihan Bahasa: Mengingati bahasa pilihan anda',
      item2: 'Sesi Akaun: Mengekalkan anda log masuk (berfungsi dengan Firebase)',
      item3: 'Tetapan Permainan: Mengingati pilihan UI dan persediaan kotak pasir anda',
      item4: 'Kuki Pengiklanan: Jika anda bersetuju, perkhidmatan iklan pihak ketiga mungkin menggunakan kuki untuk pemperibadian iklan',
    },

    security: {
      title: 'Keselamatan Data',
      p1: 'Kami melaksanakan langkah keselamatan yang sesuai untuk melindungi maklumat anda:',
      item1: 'Penyulitan Kata Laluan: Semua kata laluan disulitkan menggunakan kaedah standard industri',
      item2: 'Sambungan Selamat: Penyulitan HTTPS untuk semua penghantaran data',
      item3: 'Peraturan Keselamatan Firebase: Kawalan akses pangkalan data yang ketat',
      p2: 'Walau bagaimanapun, tiada kaedah penghantaran melalui internet adalah 100% selamat. Walaupun kami berusaha untuk melindungi data anda, kami tidak dapat menjamin keselamatan mutlak.',
    },

    retention: {
      title: 'Pengekalan Data',
      p1: 'Kami mengekalkan data anda seperti berikut:',
      item1: 'Akaun Aktif: Data dikekalkan semasa akaun anda aktif',
      item2: 'Akaun Tidak Aktif: Jika akaun anda tidak aktif selama 10 tahun, kami mungkin memadamkan data anda',
    },

    rights: {
      title: 'Hak Privasi Anda',
      description: 'Bergantung pada lokasi anda, anda mungkin mempunyai hak berikut:',
      access: {
        title: 'Akses:',
        description: 'Meminta salinan data peribadi anda',
      },
      correction: {
        title: 'Pembetulan:',
        description: 'Meminta pembetulan kepada data anda',
      },
      deletion: {
        title: 'Pemadaman:',
        description: 'Meminta pemadaman akaun dan data anda',
      },
      portability: {
        title: 'Kemudahalihan Data:',
        description: 'Meminta data anda dalam format mudah alih',
      },
      optOut: {
        title: 'Menarik Diri:',
        description: 'Menarik diri daripada komunikasi pemasaran',
      },
      contact: 'Untuk menggunakan mana-mana hak ini, sila hubungi kami di contact@zodiac-chess.com',
    },

    international: {
      title: 'Pengguna Antarabangsa',
      p1: 'Zodiac Chess dikendalikan dari New Zealand. Jika anda mengakses perkhidmatan kami dari luar New Zealand, sila ambil perhatian bahawa maklumat anda mungkin dipindahkan ke, disimpan, dan diproses di New Zealand dan negara lain di mana penyedia perkhidmatan kami beroperasi.',
      p2: 'Dengan menggunakan perkhidmatan kami, anda bersetuju dengan pemindahan maklumat anda ke negara di luar negara kediaman anda, yang mungkin mempunyai undang-undang perlindungan data yang berbeza.',
    },

    changes: {
      title: 'Perubahan kepada Dasar Privasi Ini',
      description: 'Kami mungkin mengemas kini Dasar Privasi ini dari semasa ke semasa. Kami akan memberitahu anda tentang sebarang perubahan dengan menyiarkan Dasar Privasi baharu pada halaman ini dan mengemas kini tarikh "Kemas Kini Terakhir". Perubahan penting akan dikomunikasikan melalui e-mel atau notis menonjol di laman web kami.',
    },

    contact: {
      title: 'Hubungi Kami',
      description: 'Jika anda mempunyai sebarang soalan, kebimbangan, atau permintaan mengenai Dasar Privasi ini atau amalan data kami, sila hubungi kami:',
      email: 'E-mel:',
      company: 'Syarikat:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Terma Perkhidmatan',
    lastUpdated: 'Kemas Kini Terakhir',
    back: 'Kembali',
    viewPrivacyPolicy: 'Lihat Dasar Privasi',
    acknowledgment: 'Dengan menggunakan Zodiac Chess, anda mengakui bahawa anda telah membaca, memahami, dan bersetuju untuk terikat dengan Terma Perkhidmatan ini.',
    acceptance: {
      title: '1. Penerimaan Terma',
      p1: 'Dengan mengakses dan menggunakan Zodiac Chess ("Perkhidmatan"), anda menerima dan bersetuju untuk terikat dengan Terma Perkhidmatan ini. Jika anda tidak bersetuju dengan terma ini, sila jangan gunakan Perkhidmatan.',
      p2: 'Kami berhak untuk mengubah terma ini pada bila-bila masa. Penggunaan berterusan Perkhidmatan selepas perubahan merupakan penerimaan terma yang diubah suai.',
    },
    description: {
      title: '2. Penerangan Perkhidmatan',
      p1: 'Zodiac Chess adalah permainan papan strategi dalam talian yang menampilkan buah catur haiwan unik dengan kebolehan khas. Perkhidmatan termasuk:',
      feature1: 'Permainan pemain tunggal melawan lawan AI',
      feature2: 'Padanan berbilang pemain dan permainan kompetitif',
      feature3: 'Tutorial interaktif dan sumber pembelajaran',
      feature4: 'Penciptaan akaun dan penjejakan kemajuan',
      feature5: 'Ciri langganan premium pilihan',
      feature6: 'Pilihan penyesuaian kosmetik',
    },
    accounts: {
      title: '3. Akaun Pengguna',
      eligibility: {
        title: '3.1 Kelayakan',
        p1: 'Anda mesti berumur sekurang-kurangnya 13 tahun untuk membuat akaun. Pengguna di bawah 13 tahun boleh menggunakan mod permainan tetamu dengan pengawasan ibu bapa tetapi tidak boleh membuat akaun.',
      },
      responsibilities: {
        title: '3.2 Keselamatan Akaun',
        p1: 'Anda bertanggungjawab untuk:',
        item1: 'Mengekalkan kerahsiaan kata laluan anda',
        item2: 'Semua aktiviti yang berlaku di bawah akaun anda',
        item3: 'Memberitahu kami dengan segera tentang sebarang penggunaan tanpa kebenaran',
        p2: 'Kami tidak bertanggungjawab atas sebarang kerugian atau kerosakan yang timbul daripada akses akaun tanpa kebenaran.',
      },
      prohibited: {
        title: '3.3 Aktiviti yang Dilarang',
        p1: 'Anda TIDAK boleh:',
        item1: 'Berkongsi akaun anda dengan orang lain',
        item2: 'Menggunakan berbilang akaun untuk memanipulasi kedudukan',
        item3: 'Menggunakan bot, skrip, atau alat automatik untuk bermain',
        item4: 'Mengganggu, menyalahgunakan, atau mengancam pemain lain',
        item5: 'Mengeksploitasi pepijat atau gangguan untuk kelebihan tidak adil',
        item6: 'Melakukan kejuruteraan terbalik atau cuba mengakses kod sumber kami',
        p2: 'Pelanggaran peraturan ini boleh mengakibatkan penggantungan akaun atau larangan kekal.',
      },
    },
    premium: {
      title: '4. Langganan Premium',
      billing: {
        title: '4.1 Pengebilan',
        p1: 'Langganan premium diproses melalui Stripe. Dengan membeli langganan premium, anda membenarkan kami mengenakan bayaran kepada kaedah pembayaran anda secara berulang sehingga anda membatalkan.',
        p2: 'Yuran langganan adalah:',
        item1: 'Pelan Bulanan: Dicaj setiap bulan pada ulang tahun tarikh pembelian anda',
        item2: 'Pelan Tahunan: Dicaj setiap tahun pada ulang tahun tarikh pembelian anda',
        p3: 'Harga tertakluk kepada perubahan dengan notis 30 hari kepada pelanggan aktif.',
      },
      cancellation: {
        title: '4.2 Pembatalan',
        p1: 'Anda boleh membatalkan langganan anda pada bila-bila masa melalui tetapan akaun atau dengan menghubungi sokongan. Pembatalan berkuat kuasa pada akhir tempoh pengebilan semasa anda.',
        p2: 'Anda akan mengekalkan ciri premium sehingga akhir tempoh berbayar anda, walaupun selepas pembatalan.',
      },
      refunds: {
        title: '4.3 Bayaran Balik',
        p1: 'Langganan bulanan: Tiada bayaran balik untuk bulan separa. Batalkan pada bila-bila masa untuk menghentikan caj masa depan.',
        p2: 'Langganan tahunan: Bayaran balik penuh jika diminta dalam masa 7 hari selepas pembelian. Selepas 7 hari, bayaran balik mengikut budi bicara kami.',
        p3: 'Pembelian kosmetik: Secara amnya tidak boleh dikembalikan. Hubungi sokongan untuk keadaan luar biasa.',
      },
    },
    acceptable: {
      title: '5. Dasar Penggunaan Boleh Diterima',
      p1: 'Anda bersetuju untuk menggunakan Zodiac Chess dengan cara yang hormat dan sah. Kelakuan yang dilarang termasuk:',
      item1: 'Menipu, menggodam, atau mengeksploitasi mekanik permainan',
      item2: 'Gangguan, ucapan kebencian, atau bahasa diskriminasi',
      item3: 'Spam, pengiklanan, atau permintaan',
      item4: 'Berkongsi kandungan tidak sesuai (jika sembang atau kandungan jana pengguna didayakan)',
      item5: 'Menyamar sebagai pengguna lain atau ahli kakitangan',
      item6: 'Cuba mengganggu atau merosakkan Perkhidmatan',
      p2: 'Kami berhak untuk menyiasat pelanggaran dan mengambil tindakan sewajarnya, termasuk penamatan akaun dan melaporkan kepada pihak berkuasa jika perlu.',
    },
    intellectual: {
      title: '6. Hak Harta Intelek',
      ownership: {
        title: '6.1 Kandungan Kami',
        p1: 'Semua kandungan permainan, termasuk tetapi tidak terhad kepada mekanik permainan, karya seni, animasi, kesan bunyi, kod, dan reka bentuk, dimiliki oleh Animal Chess Limited atau pemberi lesen kami.',
        p2: 'Anda diberikan lesen terhad, tidak eksklusif, tidak boleh dipindah milik untuk menggunakan Perkhidmatan untuk tujuan hiburan peribadi sahaja.',
      },
      userContent: {
        title: '6.2 Kandungan Pengguna',
        p1: 'Dengan menghantar kandungan (seperti mesej sembang, nama pengguna, atau maklumat profil), anda memberikan kami lesen di seluruh dunia, bebas royalti untuk menggunakan, memaparkan, dan mengedarkan kandungan tersebut berkaitan dengan Perkhidmatan.',
        p2: 'Anda menyatakan bahawa anda memiliki atau mempunyai hak yang diperlukan untuk sebarang kandungan yang anda hantar.',
      },
    },
    disclaimers: {
      title: '7. Penafian dan Had Liabiliti',
      p1: 'PERKHIDMATAN DISEDIAKAN "SEADANYA" TANPA JAMINAN APA-APA JENIS, SAMA ADA NYATA ATAU TERSIRAT.',
      p2: 'Kami tidak menjamin bahawa:',
      item1: 'Perkhidmatan akan tidak terganggu atau bebas ralat',
      item2: 'Kecacatan akan diperbetulkan',
      item3: 'Perkhidmatan bebas daripada virus atau komponen berbahaya',
      item4: 'Hasil daripada menggunakan Perkhidmatan akan memenuhi jangkaan anda',
      p3: 'SETAKAT MAKSIMUM YANG DIBENARKAN OLEH UNDANG-UNDANG, KAMI TIDAK BERTANGGUNGJAWAB UNTUK:',
      item5: 'Sebarang kerosakan tidak langsung, sampingan, atau akibat',
      item6: 'Kehilangan keuntungan, data, atau muhibah',
      item7: 'Gangguan perkhidmatan atau kehilangan data',
      item8: 'Kerosakan melebihi jumlah yang anda bayar kepada kami dalam 12 bulan yang lalu',
    },
    privacy: {
      title: '8. Privasi',
      p1: 'Penggunaan Perkhidmatan oleh anda juga ditadbir oleh Dasar Privasi kami, yang menerangkan cara kami mengumpul, menggunakan, dan melindungi maklumat peribadi anda.',
      p2: 'Dengan menggunakan Perkhidmatan, anda bersetuju dengan amalan data kami seperti yang diterangkan dalam Dasar Privasi.',
    },
    changes: {
      title: '9. Perubahan kepada Terma',
      p1: 'Kami berhak untuk mengubah Terma Perkhidmatan ini pada bila-bila masa. Kami akan memberitahu pengguna tentang perubahan material melalui:',
      item1: 'Pemberitahuan e-mel kepada pengguna berdaftar',
      item2: 'Notis yang menonjol di laman web',
      item3: 'Tarikh "Kemas Kini Terakhir" yang dikemas kini di bahagian atas halaman ini',
      p2: 'Penggunaan berterusan Perkhidmatan oleh anda selepas perubahan merupakan penerimaan terma yang diubah suai.',
    },
    governing: {
      title: '10. Undang-undang yang Mentadbir',
      p1: 'Terma Perkhidmatan ini ditadbir oleh undang-undang New Zealand, tanpa mengira prinsip konflik undang-undang.',
      p2: 'Sebarang pertikaian yang timbul daripada terma ini atau penggunaan Perkhidmatan oleh anda akan diselesaikan di mahkamah New Zealand.',
    },
    contact: {
      title: '11. Maklumat Hubungan',
      p1: 'Untuk soalan, kebimbangan, atau sokongan mengenai Terma Perkhidmatan ini:',
      email: 'E-mel:',
      company: 'Syarikat:',
      address: 'Alamat:',
    },
    severability: {
      title: '12. Kebolehasingan',
      p1: 'Jika mana-mana peruntukan terma ini didapati tidak boleh dikuatkuasakan atau tidak sah, peruntukan tersebut akan dihadkan atau dihapuskan setakat minimum yang perlu, dan peruntukan yang selebihnya akan kekal berkuat kuasa sepenuhnya.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Dasar Kuki',
    lastUpdated: 'Kemas Kini Terakhir',
    browserInstructions: {
      chrome: 'Tetapan → Privasi dan Keselamatan → Kuki',
      firefox: 'Tetapan → Privasi & Keselamatan → Kuki dan Data Laman',
      safari: 'Keutamaan → Privasi → Kuki dan data laman web',
      edge: 'Tetapan → Privasi, carian dan perkhidmatan → Kuki',
    },
    cookieTable: {
      name: 'Nama Kuki',
      purpose: 'Tujuan',
      duration: 'Tempoh',
      type: 'Jenis',
    },
    relatedPolicies: {
      title: 'Dasar Berkaitan',
      description: 'Untuk maklumat lanjut tentang cara kami mengendalikan data anda, sila lihat:',
      privacy: 'Dasar Privasi',
      terms: 'Terma Perkhidmatan',
    },

    introduction: {
      title: 'Pengenalan',
      p1: 'Dasar Kuki ini menerangkan cara Zodiac Chess ("kami" atau "kita") menggunakan kuki dan teknologi serupa apabila anda melawat laman web kami.',
      p2: 'Dengan menggunakan laman web kami, anda bersetuju dengan penggunaan kuki kami mengikut dasar ini. Jika anda tidak bersetuju, sila lumpuhkan kuki dalam tetapan pelayar anda atau jangan gunakan laman web kami.',
    },
    what: {
      title: 'Apakah Kuki?',
      p1: 'Kuki adalah fail teks kecil yang diletakkan pada peranti anda (komputer, telefon pintar, tablet) apabila anda melawat laman web. Ia digunakan secara meluas untuk membuat laman web berfungsi dengan cekap dan memberikan maklumat kepada pemilik laman web.',
      p2: 'Kuki mempunyai pelbagai tujuan, termasuk mengingati keutamaan anda, menganalisis penggunaan laman, dan membolehkan ciri-ciri tertentu.',
    },
    types: {
      title: 'Jenis Kuki yang Kami Gunakan',
      necessary: {
        title: '1. Kuki Perlu',
        description: 'Kuki ini penting untuk laman web berfungsi dengan betul. Tanpa kuki ini, perkhidmatan yang anda minta tidak dapat disediakan.',
        examples: 'Contoh:',
        item1: 'Kuki pengesahan - Memastikan anda kekal log masuk ke akaun anda',
        item2: 'Kuki keselamatan - Melindungi daripada aktiviti penipuan',
        item3: 'Kuki sesi - Mengekalkan keadaan permainan anda semasa sesi',
        item4: 'Keutamaan persetujuan kuki - Mengingati pilihan kuki anda',
      },
      analytics: {
        title: '2. Kuki Analitik',
        description: 'Kuki ini membantu kami memahami cara pelawat berinteraksi dengan laman web kami dengan mengumpul maklumat tanpa nama tentang lawatan halaman, masa yang dihabiskan, dan ciri yang digunakan.',
        provider: 'Pembekal: Firebase Analytics (Google)',
        purpose: 'Tujuan:',
        item1: 'Mengukur trafik laman web dan penglibatan pengguna',
        item2: 'Mengenal pasti ciri dan halaman popular',
        item3: 'Memahami demografi pengguna (julat umur, lokasi umum)',
        item4: 'Meningkatkan prestasi laman web dan pengalaman pengguna',
      },
      advertising: {
        title: '3. Kuki Pengiklanan',
        description: 'Kuki ini digunakan untuk memaparkan iklan yang berkaitan dengan anda. Ia juga mengehadkan bilangan kali anda melihat iklan dan membantu mengukur keberkesanan kempen pengiklanan.',
        provider: 'Pembekal: Google AdSense',
        purpose: 'Tujuan:',
        item1: 'Menunjukkan iklan diperibadi berdasarkan minat anda',
        item2: 'Mengukur prestasi dan penglibatan iklan',
        item3: 'Menghalang iklan yang sama dipaparkan terlalu banyak kali',
        note: 'Nota: Pelanggan Premium tidak akan melihat iklan, tanpa mengira tetapan kuki.',
      },
    },
    firstThird: {
      title: 'Kuki Pihak Pertama vs Kuki Pihak Ketiga',
      firstParty: {
        title: 'Kuki Pihak Pertama',
        description: 'Ini adalah kuki yang ditetapkan secara langsung oleh Zodiac Chess. Kami menggunakannya untuk fungsi laman yang penting, pengesahan, dan mengingati keutamaan anda.',
      },
      thirdParty: {
        title: 'Kuki Pihak Ketiga',
        description: 'Ini adalah kuki yang ditetapkan oleh perkhidmatan luaran yang kami gunakan, seperti Google Analytics dan Google AdSense. Kuki pihak ketiga tertakluk kepada dasar privasi pembekal tersebut.',
      },
    },
    specific: {
      title: 'Kuki Khusus yang Kami Gunakan',
      tableHeader: 'Di bawah adalah senarai terperinci kuki yang digunakan di laman web kami:',
    },
    control: {
      title: 'Cara Mengawal Kuki',
      consent: {
        title: '1. Sepanduk Persetujuan Kuki',
        description: 'Apabila anda pertama kali melawat laman web kami, anda akan melihat sepanduk persetujuan kuki. Anda boleh:',
        item1: 'Terima Semua - Benarkan semua kuki (perlu, analitik, dan pengiklanan)',
        item2: 'Tolak Pilihan - Hanya benarkan kuki perlu (tiada analitik atau iklan)',
        item3: 'Sesuaikan - Pilih dengan tepat jenis kuki yang anda mahu benarkan',
      },
      browser: {
        title: '2. Tetapan Pelayar',
        description: 'Kebanyakan pelayar web membenarkan anda mengawal kuki melalui tetapan mereka. Anda boleh:',
        item1: 'Sekat semua kuki',
        item2: 'Terima hanya kuki pihak pertama',
        item3: 'Padam kuki selepas setiap sesi melayari',
        item4: 'Lihat dan padam kuki individu',
        links: 'Berikut adalah pautan ke pengurusan kuki untuk pelayar popular:',
      },
      optOut: {
        title: '3. Alat Keluar',
        description: 'Untuk kuki pengiklanan khususnya, anda boleh memilih keluar daripada iklan diperibadi:',
        googleLink: 'Tetapan Iklan Google',
        googleDesc: ' - Urus iklan diperibadi Google',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Keluar daripada pengiklanan berasaskan minat',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - Alat keluar khusus EU',
      },
    },
    impact: {
      title: 'Kesan Melumpuhkan Kuki',
      p1: 'Jika anda melumpuhkan atau menolak kuki, sila ambil perhatian bahawa:',
      item1: 'Beberapa bahagian laman web mungkin tidak berfungsi dengan betul',
      item2: 'Anda mungkin perlu memasukkan semula keutamaan anda setiap lawatan',
      item3: 'Anda mungkin dilog keluar daripada akaun anda',
      item4: 'Kuki perlu diperlukan untuk laman berfungsi - melumpuhkannya akan menghalang anda daripada menggunakan ciri teras',
    },
    updates: {
      title: 'Kemas Kini kepada Dasar Kuki Ini',
      p1: 'Kami mungkin mengemas kini Dasar Kuki ini dari semasa ke semasa untuk mencerminkan perubahan dalam amalan kami atau atas sebab undang-undang, peraturan, atau operasi.',
      p2: 'Kami akan memberitahu anda tentang perubahan penting dengan mengemas kini tarikh "Kemas Kini Terakhir" di bahagian atas halaman ini. Sila semak dasar ini secara berkala.',
    },
    contact: {
      title: 'Hubungi Kami',
      p1: 'Jika anda mempunyai soalan tentang penggunaan kuki kami atau Dasar Kuki ini, sila hubungi kami:',
      email: 'E-mel:',
      company: 'Syarikat:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Penguin',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',
  },

  // Piece names
  pieces: {
    Bear: 'Beruang',
    Crane: 'Burung Jenjang',
    Frog: 'Katak',
    Fungi: 'Cendawan',
    Goat: 'Kambing',
    Monkey: 'Monyet',
    Octopus: 'Sotong Kurita',
    Penguin: 'Penguin',
    Rhino: 'Badak Sumbu',
    Snake: 'Ular',
    Tree: 'Pokok',
    Virus: 'Virus',
    Wolf: 'Serigala',
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
